import { render, staticRenderFns } from "./Downtime.vue?vue&type=template&id=25004ef9&scoped=true"
import script from "./Downtime.vue?vue&type=script&lang=ts"
export * from "./Downtime.vue?vue&type=script&lang=ts"
import style0 from "./Downtime.vue?vue&type=style&index=0&id=25004ef9&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25004ef9",
  null
  
)

export default component.exports